import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { first } from 'rxjs/operators';
import { RoLaborFullUtilities } from '../class/ro-labor-full-utilities';
import { RoLaborFull } from '../interface/ro-labor-full';
import { firstValueFrom } from 'rxjs';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class RoLaborService {
  private _isFromMatrix = false;

  constructor(
    private _http: HttpClient,
    private _dataService: DataService
  ) { }

  async addOrUpdate(ro: string, roLaborFull: RoLaborFull): Promise<string> {
    const roLabor = JSON.stringify(RoLaborFullUtilities.complyApi(roLaborFull));
    const url = `${environment.mkgoURL}/api/v1/os/${ro}/labors`;
    const header = await firstValueFrom(this._dataService.httpOptions(this._isFromMatrix));
    const resp: any = await this._http.post(url, roLabor, header).pipe(first()).toPromise();
    return resp['id'];
  }

  async updateMechanics(ro: string, itemIds: string[], mechanic: string | null): Promise<any> {
    const url = `${environment.mkgoURL}/api/v1/os/${ro}/labors/mechanics`;
    const header = await firstValueFrom(this._dataService.httpOptions(this._isFromMatrix));
    const body = JSON.stringify({
      mode: "single",
      itemIds,
      mechanic
    });

    return this._http.patch(url, body, header).pipe(first()).toPromise();
  }

  async updateChiefMechanics(ro: string, itemIds: string[], chiefMechanic: string | null): Promise<any> {
    const url = `${environment.mkgoURL}/api/v1/os/${ro}/labors/mechanics`;
    const header = await firstValueFrom(this._dataService.httpOptions(this._isFromMatrix));
    const body = JSON.stringify({
      mode: "chief",
      itemIds,
      chiefMechanic
    });

    return this._http.patch(url, body, header).pipe(first()).toPromise();
  }

  async delete(ro: string, labor: string): Promise<any> {
    const url = `${environment.mkgoURL}/api/v1/os/${ro}/labors/${labor}`;
    const header = await firstValueFrom(this._dataService.httpOptions(this._isFromMatrix));
    const resp = await this._http.delete(url, header).pipe(first()).toPromise();
    return resp;
  }
}
